// To-Top Block
// Scroll to top functionality
require('smoothscroll-polyfill').polyfill();
let toTopButtons = document.querySelectorAll('.to-top-button');
if (toTopButtons) {
    [].forEach.call(toTopButtons, function (button) {
        button.addEventListener('click', function () {
            window.scroll({ top: 0, left: 0, behavior: 'smooth' });
        });
    });
}